import JSZip from 'jszip';

async function detectZipBasedFile(file) {
    const zip = await JSZip.loadAsync(file);

    if(zip.files) {
        const files = Object.keys(zip.files);

        if (files.includes("word/document.xml")) return "docx";
        if (files.includes("xl/workbook.xml")) return "xlsx";
        if (files.includes("content.xml")) return "odt";
    }

    return "zip";
}

function readBytes(file, start, end) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(new Uint8Array(e.target.result));
        reader.readAsArrayBuffer(file.slice(start, end));
    });
}

export async function detectFileType({file, allowedExtensions = {
    word: 'vnd.openxmlformats-officedocument.wordprocessingml.document',
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    png: "image/png",
    gif: "image/gif",
    pdf: "application/pdf",
    csv: "text/csv",
    odt: "application/vnd.oasis.opendocument.text",
    jpeg: "image/jpeg",
    jpg: "image/jpeg",
    zip: "application/zip",
    msg: "application/vnd.ms-outlook",
    eml: "message/rfc822",
}}) {
    const header = await readBytes(file, 0, 8);
    const match = (sig) => sig.every((b, i) => header[i] === b);

    // PDF
    if (match([0x25, 0x50, 0x44, 0x46])) return "pdf";

    // PNG
    if (match([0x89, 0x50, 0x4E, 0x47])) return "png";

    // GIF
    if (match([0x47, 0x49, 0x46, 0x38])) return "gif";

    // JPEG
    if (match([0xFF, 0xD8, 0xFF])) return "jpeg";

    // ZIP - docx, xlsx, odt, ou zip comum
    if (match([0x50, 0x4B, 0x03, 0x04])) {
        return await detectZipBasedFile(file);
    }

    // DOC / XLS antigos (OLE2)
    if (match([0xD0, 0xCF, 0x11, 0xE0])) {
        return "ole2";
    }

    //EM CASO DE NÃO SER NENHUMA DAS OPÇÕES ANTERIORES SIGNIFICA QUE É UM ARQUIVO COM ASSINATURA FRACA. (txt, csv, eml etc.)
    //PARA ESTES, MANTEMOS A VERIFICAÇÃO POR MIME/TYPE E EXTENSÃO (EM CASO DO MIMETYPE NÃO EXISTIR)
    let t = file.type;

    if (!t)
        t = file.name.split('.').pop().toLowerCase();

    let extension = null;

    for(const [key,value] of Object.entries(allowedExtensions)){
        if(value == t || value == `.${t}`){
            extension = key;
            break;
        }
    }

    return extension;
}
